const GRADE_LEVEL_LABELS: Record<string, string> = {
  'Birth-3': 'Birth - 3 years old',
  'Pre-K': 'Pre-K',
  K: 'Kindergarten',
  '1': '1st grade',
  '2': '2nd grade',
  '3': '3rd grade',
  'Adult-Transition': 'Adult transition',
}

const NUMBERED_GRADES = ['4', '5', '6', '7', '8', '9', '10', '11', '12']

// Each label must be one the backend accepts (services/pathways-api/sdigenerator/valid_grades.go).
export function sdiGradeLevel(goalGrades: string[]): string | undefined {
  const firstGrade = goalGrades[0]
  if (NUMBERED_GRADES.includes(firstGrade)) {
    return `${firstGrade}th grade`
  }
  return GRADE_LEVEL_LABELS[firstGrade]
}
